import React, { Component } from 'react';
import { connect } from 'react-redux';
import Toolbar from '../toolbar/Toolbar';
import {isMigratableBrand} from '../../util/AppUtil';
import UniversalHeader from '@sfly/uig-universal-header';
import queryString from 'query-string';


class ToolbarTemplate extends Component {
    constructor(props) {
        super(props);
        this.urlParams = queryString.parse(window.location.search);
        this.fromAmazon = this.urlParams.amazon === 'true'
    }

    getUniversalToolbarBrand() {
        const b = this.props.theme && this.props.theme.toUpperCase();
        switch (b) {
            case 'SFLY':
            case 'INC':
            case 'TP':
                return b;
            case 'MLT':
            case 'PRESCHOOLS':
            case 'PRESTIGE':
            case 'LTI':
            case 'LTSMILES':
            case 'COMMUNITY':
                return 'INC';
            default:
                return 'SFLY';
        }
    }

    render() {
        if (isMigratableBrand(this.props.brand) || this.fromAmazon) {
            return (
                <React.Fragment>
                    <Toolbar fromAmazon ={this.fromAmazon}/>
                    {this.props.centralConfig.show_downtime_banner && <div className={'downtime-banner'}><img src='//cdn-image.staticsfly.com/i/home/error_md.png' alt='error_sybl'/><p>{this.props.centralConfig.show_downtime_banner_error}</p></div>}
                    {this.props.children}
                </React.Fragment>
            );
        } else {
            return (
                <React.Fragment>
                    {!this.props.hideHeader && <UniversalHeader hideNavbar={true} hideToolbar={true} brandType={this.getUniversalToolbarBrand()} />}
                    {this.props.centralConfig.show_downtime_banner && <div className={'downtime-banner'}><img src='//cdn-image.staticsfly.com/i/home/error_md.png' alt='error_sybl' /><p>{this.props.centralConfig.show_downtime_banner_error}</p></div>}
                    {this.props.children}
                </React.Fragment>
            );
        }
    }
}

const mapStateToProps = (state) => {
    return {
        theme: state.app.theme,
        brand: state.app.brand,
        centralConfig: state.app.centralConfig
    };
};

export default connect(mapStateToProps)(ToolbarTemplate);
